export enum ELanguages {
	RU = 'ru',
}
